module.exports = __webpack_public_path__ + "media/elevadizo/buque-di-ap-410e9cfc.png";